import React, { PureComponent } from "react";
import "./spinner.css";

export default class Spinner extends PureComponent {
    static get contextTypes() {
        return {
            muiTheme: React.PropTypes.object,
        };
    }

    render() {
        const colors = this.context.muiTheme.palette;

        return (
            <div className="appointment-spinner">
                <div className="rect1" style={{ backgroundColor: colors.primary3color }}></div>
                <div className="rect2" style={{ backgroundColor: colors.primary3color }}></div>
                <div className="rect3" style={{ backgroundColor: colors.primary3color }}></div>
                <div className="rect4" style={{ backgroundColor: colors.primary3color }}></div>
                <div className="rect5" style={{ backgroundColor: colors.primary3color }}></div>
            </div>
        );
    }
}


/** WEBPACK FOOTER **
 ** ./src/widgets/appointment-widget/components/spinner.js
 **/